var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _path11, _path12, _rect3, _path13, _rect4, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 570,
    viewBox: "0 0 388 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.332 34.3027H71.1405L71.1405 124.025H55.332L55.332 34.3027ZM71.1432 47.4964H86.9516L86.9516 147.777H100.123L100.123 234.861H86.9495V224.302H71.1432L71.1432 47.4964Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.158 76.5244H10.541L10.541 126.234H26.3521L26.3521 195.273H55.3344L55.3344 123.471H42.158L42.158 76.5244Z",
    fill: "#FFC700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.932 2.63672L100.123 2.63672L100.123 150.415H115.932L115.932 2.63672ZM129.106 21.1089H115.933L115.933 137.22H129.106L129.106 21.1089Z",
    fill: "#FFC700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.091 34.2988H142.282L142.282 163.605H158.091V34.2988ZM173.902 47.4925H158.093L158.093 179.437H173.902L173.902 47.4925Z",
    fill: "#FFC700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.03 34.3027H229.222L229.222 208.47H245.03L245.03 34.3027ZM260.841 47.4964H245.033L245.033 208.469H260.841V47.4964Z",
    fill: "#FFC700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.191 47.4941H271.383V208.467H287.191V47.4941ZM303.002 60.6878H287.194V237.494H303.002V60.6878Z",
    fill: "#FFC700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.559 0L187.068 0L187.068 192.783H201.559L201.559 0ZM216.051 19.6727L201.56 19.6727L201.56 216.39H216.051L216.051 19.6727Z",
    fill: "#FFC700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.35 76.5244H316.177V211.108H329.35V208.468H345.158V92.357H329.35V76.5244Z",
    fill: "#FFC700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.421 200.554H229.229V282.359H213.425V284.995H200.252L200.252 219.023H213.421V200.554Z",
    fill: "#FFC700"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.103 150.414H115.93L115.93 266.525H129.103V150.414ZM142.28 163.607H129.107V279.718H142.28V163.607Z",
    fill: "#FFC700"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152.817,
    y: 192.636,
    width: 34.2517,
    height: 89.7224,
    fill: "#FFC700"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 245.034,
    y: 208.469,
    width: 26.3475,
    height: 73.889,
    fill: "#FFC700"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.158 2.62891L331.984 2.62891V47.4901H345.158V2.62891ZM316.175 21.1027H331.984L331.984 65.9639H316.175V47.4916H300.367V34.2972H316.175V21.1027Z",
    fill: "#FFC700"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.324 5.27148L345.151 5.27148V47.4938H358.324V5.27148ZM345.152 47.4961H331.979V63.3295H345.152V47.4961Z",
    fill: "#E25B00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 345.153,
    y: 92.3584,
    width: 13.1737,
    height: 92.3613,
    fill: "#E25B00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.925 5.27148L129.099 5.27148V21.1048L142.272 21.1048L142.272 163.605H129.098V150.409H115.925V137.214H129.098L129.098 21.1049H115.925V5.27148ZM158.082 163.606H142.273V266.522H158.082V163.606ZM173.888 63.3297H187.062L187.062 192.636H173.89V192.636H158.082V179.442H173.888L173.888 63.3297Z",
    fill: "#E25B00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 229.226,
    y: 208.469,
    width: 15.8085,
    height: 73.889,
    fill: "#E25B00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.189 47.5H302.998V47.5024H316.17V240.142H302.997V60.6945H287.189V47.5ZM316.17 65.9698H329.344V76.5254H316.17V65.9698Z",
    fill: "#E25B00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.379 47.4961H260.84V208.469H271.379V47.4961ZM287.187 208.47H271.379V282.359H287.187V208.47Z",
    fill: "#E25B00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.239 5.2793L216.047 5.2793V21.1126L229.22 21.1126L229.22 200.557H216.047L216.047 21.1127L200.239 21.1127V5.2793ZM216.044 192.638H187.062V284.999H216.044V192.638Z",
    fill: "#E25B00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1445 34.2988H86.953V47.4933H71.1445V34.2988ZM86.9557 47.4925H100.129L100.129 150.409H86.9557L86.9557 47.4925ZM115.932 150.412H100.123L100.123 253.329H115.932L115.932 150.412Z",
    fill: "#E25B00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9795 63.333H42.1532V76.5275H28.9795V63.333ZM42.1564 76.526H55.3301L55.3301 124.026H42.1564L42.1564 76.526ZM71.134 124.029H55.3255L55.3255 213.752H71.134L71.134 124.029Z",
    fill: "#E25B00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 176.805H42.1559V193.958H57.9644V208.471H71.1382V221.666H86.9466V234.86H100.12V250.694H129.103V265.208H158.085V282.36H229.223V263.888H258.205V250.694H287.187V234.86H302.996V221.666H316.17V208.471H331.978V192.638H345.152V176.805H387.308V321.944H0L0 176.805Z",
    fill: "#DC4200"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.539 321.944H376.769V424.861H10.539L10.539 321.944Z",
    fill: "#DC4200"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.617 424.861H355.691V533.055H31.617L31.617 424.861Z",
    fill: "#DC4200"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.617 533.055H126.468V551.528H115.929V570H42.1559V551.528H31.617L31.617 533.055Z",
    fill: "#DC4200"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M260.84 533.055H355.691V551.528H345.152V570H271.379V551.528H260.84V533.055Z",
    fill: "#DC4200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFries);
export default __webpack_public_path__ + "static/media/fries.2bb4b37b2dd3d21bfefbf3cb785cd0f7.svg";
export { ForwardRef as ReactComponent };